if (!customElements.get('puffy-prime-cart-upsell')) {
  customElements.define(
    'puffy-prime-cart-upsell',
    class PuffyPrimeCartUpsell extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-pp-prime-add]');
        this.buttonLabel = this.querySelector('[data-pp-prime-button-label]');
        this.status = this.querySelector('[data-pp-prime-status]');

        if (!this.button || !this.dataset.variantId || !this.dataset.sellingPlanId) return;

        this.abortController?.abort();
        this.abortController = new AbortController();
        this.button.addEventListener('click', () => this.addPrime(), { signal: this.abortController.signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      async addPrime() {
        if (this.button.getAttribute('aria-busy') === 'true') return;

        const defaultLabel = this.buttonLabel?.textContent || 'ADD PRIME';
        this.setLoading(true);
        this.setStatus('');

        try {
          const sections = [];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:bundled-sections', {
              bubbles: true,
              detail: { sections }
            })
          );

          const response = await fetch(theme.routes.cart_add_url, {
            ...theme.utils.fetchConfig('javascript'),
            headers: {
              ...theme.utils.fetchConfig('javascript').headers,
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(this.dataset.variantId),
                  quantity: 1,
                  selling_plan: Number(this.dataset.sellingPlanId)
                }
              ],
              sections,
              sections_url: window.location.pathname
            })
          });

          const parsedState = await response.json();
          if (!response.ok || parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || 'Prime could not be added.');
          }

          const cartResponse = await fetch(theme.routes.cart_url, theme.utils.fetchConfig('json', 'GET'));
          if (!cartResponse.ok) {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
            return;
          }

          const cart = await cartResponse.json();
          cart.sections = parsedState.sections;

          if (theme.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: 'puffy-prime-upsell',
              productVariantId: this.dataset.variantId,
              cart
            });
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          }
        } catch (error) {
          console.error(error);
          this.setStatus(`${error.message || 'Prime could not be added.'} Please try again.`);
          this.setLoading(false, defaultLabel);
        }
      }

      setLoading(isLoading, label) {
        this.button.toggleAttribute('disabled', isLoading);
        this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        if (this.buttonLabel) this.buttonLabel.textContent = isLoading ? 'ADDING PRIME…' : label;
      }

      setStatus(message) {
        if (this.status) this.status.textContent = message;
      }
    }
  );
}
